import { GoogleMapsCountryDTO } from "../../shared/dtos/googleMapsCountryDTO";

export const COUNTRIES: GoogleMapsCountryDTO[] = [
  {
    label: 'Internacional',
    value: -1,
    code: 'INT',
    lat: -34.901112,
    lng: -56.164532,
    zoom: 8,
  },
  {
    label: 'Uruguay',
    value: 229,
    code: 'UY',
    lat: -34.901112,
    lng: -56.164532,
    zoom: 8,
  },
  {
    label: 'Argentina',
    value: 13,
    code: 'AR',
    lat: -34.603722,
    lng: -58.381592,
    zoom: 8,
  },
  {
    label: 'Brasil',
    value: 33,
    code: 'BR',
    lat: -15.793889,
    lng: -47.882778,
    zoom: 8,
  },
  {
    label: 'Chile',
    value: 46,
    code: 'CL',
    lat: -33.447487,
    lng: -70.673676,
    zoom: 8,
  },
  {
    label: 'Colombia',
    value: 52,
    code: 'CO',
    lat: 4.624335,
    lng: -74.063644,
    zoom: 8,
  },
  {
    label: 'Paraguay',
    value: 172,
    code: 'PY',
    lat: -25.30066,
    lng: -57.63591,
    zoom: 8,
  },
  {
    label: 'Mexico',
    value: 146,
    code: 'MX',
    lat: 19.43944,
    lng: -99.07212,
    zoom: 8,
  },
  {
    label: 'Costa Rica',
    value: 60,
    code: 'CR',
    lat: 9.93678,
    lng: -84.08230,
    zoom: 8,
  },
  {
    label: 'Peru',
    value: 173,
    code: 'PE',
    lat: -12.04779,
    lng: -77.04283,
    zoom: 8,
  },
  {
    label: 'Ecuador',
    value: 66,
    code: 'EC',
    lat: -0.18844,
    lng: -78.46962,
    zoom: 8,
  },
  {
    label: 'Antigua and Barbuda',
    code: 'AG',
    lat: 17.060816,
    lng: -61.796428,
    value: 9,
    zoom: 8
  },
  {
    label: 'Bahamas',
    code: 'BS',
    lat: 25.034280,
    lng: -77.396280,
    value: 19,
    zoom: 8
  },
  {
    label: 'Barbados',
    code: 'BB',
    lat: 13.193887,
    lng: -59.543198,
    value: 22,
    zoom: 8
  },
  {
    label: 'Belise',
    code: 'BZ',
    lat: 17.504566,
    lng: -88.196213,
    value: 25,
    zoom: 8
  },
  {
    label: 'Bolivia',
    code: 'BO',
    lat: -16.500000,
    lng: -68.150002,
    value: 29,
    zoom: 8
  },
  {
    label: 'Brasil',
    code: 'BR',
    lat: -15.780148,
    lng: -47.929169,
    value: 33,
    zoom: 8
  },
  {
    label: 'Canada',
    code: 'CA',
    lat: 45.421532,
    lng: -75.697189,
    value: 42,
    zoom: 8
  },
  {
    label: 'Cuba',
    code: 'CU',
    lat: 23.113592,
    lng: -82.366592,
    value: 62,
    zoom: 8
  },
  {
    label: 'Dominica',
    code: 'DM',
    lat: 15.309168,
    lng: -61.379355,
    value: 64,
    zoom: 8
  },
  {
    label: 'República Dominicana',
    code: 'DO',
    lat: 18.486058,
    lng: -69.931212,
    value: 65,
    zoom: 8
  },
  {
    label: 'El Salvador',
    code: 'SV',
    lat: 13.692940,
    lng: -89.218191,
    value: 68,
    zoom: 8
  },
  {
    label: 'Grenada',
    code: 'GD',
    lat: 12.056098,
    lng: -61.748800,
    value: 89,
    zoom: 8
  },
  {
    label: 'Guatemala',
    code: 'GT',
    lat: 14.634915,
    lng: -90.506882,
    value: 94,
    zoom: 8
  },
  {
    label: 'Guyana',
    code: 'GY',
    lat: 6.804439,
    lng: -58.155266,
    value: 99,
    zoom: 8
  },
  {
    label: 'Haiti',
    code: 'HT',
    lat: 18.594395,
    lng: -72.307433,
    value: 100,
    zoom: 8
  },
  {
    label: 'Honduras',
    code: 'HN',
    lat: 14.081999,
    lng: -87.206619,
    value: 102,
    zoom: 8
  },
  {
    label: 'Jamaica',
    code: 'JM',
    lat: 18.012749,
    lng: -76.801741,
    value: 113,
    zoom: 8
  },
  {
    label: 'Nicaragua',
    code: 'NI',
    lat: 12.136389,
    lng: -86.251389,
    value: 157,
    zoom: 8
  },
  {
    label: 'Panama',
    code: 'PA',
    lat: 8.983333,
    lng: -79.516670,
    value: 170,
    zoom: 8
  },
  {
    label: 'San Cristóbal y Nevis',
    code: 'KN',
    lat: 17.300000,
    lng: -62.733334,
    value: 189,
    zoom: 8
  },
  {
    label: 'Santa Lucía',
    code: 'LC',
    lat: 13.909444,
    lng: -60.978893,
    value: 194,
    zoom: 8
  },
  {
    label: 'San Vicente y las Granadinas',
    code: 'VC',
    lat: 13.158720,
    lng: -61.224450,
    value: 192,
    zoom: 8
  },
  {
    label: 'Surinam',
    code: 'SR',
    lat: 5.866380,
    lng: -55.166820,
    value: 209,
    zoom: 8
  },
  {
    label: 'Trinidad y Tobago',
    code: 'TT',
    lat: 10.691803,
    lng: -61.222503,
    value: 221,
    zoom: 8
  },
  {
    label: 'Estados Unidos',
    code: 'US',
    lat: 38.907192,
    lng: -77.036873,
    value: 75,
    zoom: 8
  },
  {
    label: 'Venezuela',
    code: 'VE',
    lat: 10.480594,
    lng: -66.903603,
    value: 232,
    zoom: 8
  },
  {
    label: 'España',
    value: 73,
    code: 'ES',
    lat: 40.416775,
    lng: -3.703790,
    zoom: 13,
  },
  {
    label: 'Francia',
    value: 82,
    code: 'FR',
    lat: 48.856613,
    lng: 2.352222,
    zoom: 13,
  },
  {
    label: 'Italia',
    value: 112,
    code: 'IT',
    lat: 41.902784,
    lng: 12.496366,
    zoom: 13,
  },
  {
    label: 'Reino Unido',
    value: 180,
    code: 'GB',
    lat: 51.507351,
    lng: -0.127758,
    zoom: 13,
  },
  {
    label: 'Alemania',
    value: 4,
    code: 'DE',
    lat: 52.520008,
    lng: 13.404954,
    zoom: 13,
  },
  {
    label: 'China',
    value: 47,
    code: 'CN',
    lat: 39.904202,
    lng: 116.407394,
    zoom: 13,
  },
  {
    label: 'Japón',
    value: 114,
    code: 'JP',
    lat: 35.689487,
    lng: 139.691711,
    zoom: 13,
  },
  {
    label: 'Tailandia',
    value: 211,
    code: 'TH',
    lat: 13.756331,
    lng: 100.501762,
    zoom: 13,
  },
  {
    label: 'India',
    value: 105,
    code: 'IN',
    lat: 28.613939,
    lng: 77.209023,
    zoom: 13,
  },
  {
    label: 'Indonesia',
    value: 106,
    code: 'ID',
    lat: -6.208763,
    lng: 106.845599,
    zoom: 13,
  },
];